module.exports = __webpack_public_path__ + "static/media/numpy.febb3c8c.svg";